import React from 'react';

import { useGetEmergencyVisit } from '@hooks/api/emergency-visit';
import { useCuration } from '@hooks/useCuration';
import { useSession } from '@hooks/useSession';

import Content from './Content';

const EmergencyVisit: React.FC<{ id?: string }> = ({ id = '' }) => {
  const {
    state: { activeProfile, isCurator },
  } = useSession();
  const {
    state: { isCreating, isEditing },
    finishAddingRecord,
    stopEditingRecord,
  } = useCuration();
  const [patient_id] = [activeProfile?.patient_id];

  const { data, loading } = useGetEmergencyVisit({
    record_id: id,
  });

  const handleSubmit = () => {
    stopEditingRecord();
    finishAddingRecord();
  };

  return (
    <Content
      data={data}
      isCreating={isCreating}
      isCurator={isCurator}
      isEditing={isEditing}
      loading={loading}
      onSubmit={handleSubmit}
      patientId={patient_id}
    />
  );
};

export default EmergencyVisit;
